import libPhoneNumber from "google-libphonenumber";

const phoneUtil = libPhoneNumber.PhoneNumberUtil.getInstance();
const PNF = libPhoneNumber.PhoneNumberFormat;

export default function formatInvoicePhone(phoneNumber) {
    try {
        const phone = phoneUtil.parse(phoneNumber, 'US');
        const national = phoneUtil.format(phone, PNF.NATIONAL);
        if (!String(phoneNumber).trim().startsWith('+')) return national;
        return phone.getCountryCode() === 1
            ? '+1 ' + national
            : phoneUtil.format(phone, PNF.INTERNATIONAL);
    } catch (err) {
        return phoneNumber;
    }
}
